import { createContext, useContext, useState } from 'react';

type IsScrolledContextType = {
  isContentScrolled?: boolean;
  setIsContentScrolled?: React.Dispatch<React.SetStateAction<boolean>>;
};

const IsScrolledContext = createContext<IsScrolledContextType>({});

export const useIsScrolledContext = () => {
  const context = useContext(IsScrolledContext);
  if (!context) {
    throw new Error('useIsScrolledContext must be used within a IsScrolledContextProvider');
  }
  return context;
};

export const IsScrolledContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isContentScrolled, setIsContentScrolled] = useState(false);

  return (
    <IsScrolledContext.Provider value={{ isContentScrolled, setIsContentScrolled }}>
      {children}
    </IsScrolledContext.Provider>
  );
};
